import React, { Fragment } from 'react'
import cn from 'classnames'
import { Box, Typography, makeStyles } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import { styles } from './styles'
import useSmallScreen from '../useSmallScreen'
import { CheckDraftIconMobile } from '../../../../Icons/CheckDraftIconMobile'

const useStyles = makeStyles(() => styles)

export const SelfServeSteps = ({
  activeTabIndex,
  isSubmitted,
  channel,
  isEDDM,
  isADM,
  cypress_id,
}) => {
  const classes = useStyles()
  const smallScreen = useSmallScreen()

  const HEADER_TITLE = {
    HOME: 'Home',
    CAMPAIGN_DETAILS: 'Details',
    CAMPAIGN_AUDIENCE: isEDDM ? 'Segments' : 'Audience',
    FLYER_BUILDER: 'Design',
    UPLOAD_DESIGN: 'Upload design',
    FLYER_CANVAS: 'Flyer canvas',
    SUBMIT: 'Submit',
  }

  const STEPS = [
    { title: HEADER_TITLE.HOME },
    { title: HEADER_TITLE.CAMPAIGN_AUDIENCE },
    { title: HEADER_TITLE.FLYER_BUILDER },
    { title: HEADER_TITLE.CAMPAIGN_DETAILS },
    { title: HEADER_TITLE.SUBMIT },
  ]

  const ADM_STEPS = [
    { title: HEADER_TITLE.HOME },
    { title: HEADER_TITLE.CAMPAIGN_AUDIENCE },
    { title: HEADER_TITLE.FLYER_BUILDER },
    { title: HEADER_TITLE.SUBMIT },
  ]

  // EDDM and ADM both use 3 steps (Segments/Audience, Design, Submit)
  const useShortSteps = isADM || isEDDM
  const steps = useShortSteps ? ADM_STEPS : STEPS

  const styles = {
    tabsWrapper: useShortSteps ? classes.tabsWrapperADM : classes.tabsWrapper,
    line: useShortSteps ? classes.lineADM : classes.line,
    notActiveLine: useShortSteps ? classes.notActiveLineADM : classes.notActiveLine,
  }

  return (
    <Box className={cn(styles.tabsWrapper, 'makeStyles-tabsWrapper')}>
      {steps.map((item: any, index: any) => {
        const isChecked = index <= activeTabIndex

        if (index === 0) return null

        if (smallScreen) {
          return (
            <Fragment key={index}>
              <Box
                key={`${item.title}-${index}`}
                className={classes.tabWrapper}
              >
                <div className={classes.progressDraftBar}>
                  {isChecked || isSubmitted ? (
                    <Fragment>
                      <CheckDraftIconMobile color={'#1D2943'} />
                      {index < steps.length - 1 && (
                        <div className={styles.line} />
                      )}
                    </Fragment>
                  ) : (
                    <Fragment>
                      <CheckDraftIconMobile
                        color={
                          index > activeTabIndex + 1 ? '#CDCDF4' : '#004360'
                        }
                      />
                      {index < steps.length - 1 && (
                        <div className={styles.notActiveLine} />
                      )}
                    </Fragment>
                  )}
                </div>
                <Typography
                  className={cn(classes.tab, {
                    [classes.activeTab]:
                      activeTabIndex + 1 === index || isSubmitted,
                  })}
                  cypress_id={cypress_id}
                >
                  {item.title}
                </Typography>
              </Box>
            </Fragment>
          )
        }
        return (
          <Fragment key={index}>
            {isChecked || isSubmitted ? (
              <CheckCircleIcon color={'disabled'} />
            ) : (
              <RadioButtonUncheckedIcon
                color={index > activeTabIndex + 1 ? 'disabled' : 'inherit'}
              />
            )}
            <Box key={`${item.title}-${index}`} className={classes.tabWrapper}>
              <Typography
                className={cn(classes.tab, {
                  [classes.activeTab]:
                    activeTabIndex + 1 === index || isSubmitted,
                })}
                cypress_id={cypress_id}
              >
                {item.title}
              </Typography>
            </Box>
          </Fragment>
        )
      })}
    </Box>
  )
}
